<div class="c-linkable-image-container-preview">
	{{#each children}}
		<div class="c-linkable-image-container-preview__item">
			<img class="c-linkable-image-container-preview__image" src="{{getPreviewUrl image}}" alt={{getLocaleText image_alt}} />
			<p>{{getLocaleText link.title}}</p>
		</div>
	{{/each}}
</div>
